export const REFERRAL = "refer";
export const INVITE_TOKEN = "inviteToken";
